const EBML_MAGIC = [0x1a, 0x45, 0xdf, 0xa3];

export const isWebmMimeType = (mimeType) =>
  String(mimeType || "").toLowerCase().includes("webm");

/**
 * Detecta o container real pelos magic bytes (Safari/iPhone mentem MIME com frequência).
 * @returns {'webm'|'ogg'|'mp4'|'unknown'}
 */
export const sniffAudioContainer = async (blob) => {
  try {
    const header = new Uint8Array(await blob.slice(0, 12).arrayBuffer());
    if (
      header.length >= 4 &&
      EBML_MAGIC.every((byte, index) => header[index] === byte)
    ) {
      return "webm";
    }
    // OggS
    if (
      header.length >= 4 &&
      header[0] === 0x4f &&
      header[1] === 0x67 &&
      header[2] === 0x67 &&
      header[3] === 0x53
    ) {
      return "ogg";
    }
    // ....ftyp (MP4/M4A/AAC)
    if (
      header.length >= 8 &&
      header[4] === 0x66 &&
      header[5] === 0x74 &&
      header[6] === 0x79 &&
      header[7] === 0x70
    ) {
      return "mp4";
    }
    return "unknown";
  } catch (_) {
    return "unknown";
  }
};

/**
 * Um WebM válido começa com o header EBML. Gravações que perderam o primeiro
 * chunk do MediaRecorder começam no meio de um Cluster e são indecodificáveis:
 * detectamos aqui para avisar o usuário em vez de subir um arquivo que só vai
 * falhar na conversão do servidor.
 */
export const hasValidWebmHeader = async (blob) => {
  try {
    const container = await sniffAudioContainer(blob);
    return container === "webm";
  } catch (_) {
    return true;
  }
};

export const assertRecordedAudioIsValid = async (blob, mimeType) => {
  const container = await sniffAudioContainer(blob);
  // MP4 rotulado como webm: não tratar como webm corrompido — o sniff corrige no envio.
  if (container === "mp4" || container === "ogg") {
    return;
  }
  if (!isWebmMimeType(mimeType) && !isWebmMimeType(blob?.type)) {
    return;
  }
  if (container !== "webm") {
    throw new Error(
      "A gravação ficou corrompida e não pôde ser enviada. Grave o áudio novamente."
    );
  }
};

export default assertRecordedAudioIsValid;

